const menuChapters = document.querySelectorAll('.Navigation-menuChapterButton')
const hashLinks = document.querySelectorAll(
  '.MenuItem--hashLink .MenuItem-link',
)

function closeAllNavigationChapters() {
  Array.prototype.forEach.call(menuChapters, function (chapter) {
    chapter.setAttribute('aria-expanded', false)
    if (document.getElementById(chapter.getAttribute('aria-controls'))) {
      document.getElementById(chapter.getAttribute('aria-controls')).hidden =
        true
    }
  })
}

function toggleNavigationChapter(item) {
  const expanded = item.getAttribute('aria-expanded') === 'true'

  if (!expanded) {
    document.querySelector('.Navigation').classList.add('--overlay--open')

    closeAllNavigationChapters()
  } else {
    document.querySelector('.Navigation').classList.remove('--overlay--open')
  }

  item.setAttribute('aria-expanded', !expanded)
  document.getElementById(item.getAttribute('aria-controls')).hidden = expanded

  if (!expanded) {
    document.getElementById(item.getAttribute('aria-controls')).scrollTop = 0
  }
}

if (menuChapters) {
  document
    .querySelector('.Navigation-backdrop')
    .addEventListener('click', function () {
      closeAllNavigationChapters()
      document.querySelector('.Navigation').classList.remove('--overlay--open')
    })

  Array.prototype.forEach.call(menuChapters, function (item) {
    item.addEventListener('click', function () {
      toggleNavigationChapter(this)
    })
  })
}

if (hashLinks) {
  Array.prototype.forEach.call(hashLinks, function (item) {
    item.addEventListener('click', function () {
      closeAllNavigationChapters()
      document.querySelector('.Navigation').classList.remove('--overlay--open')
    })
  })
}
